export enum VerifyEmailFormEnums {
  IMAGE_ALT = 'Carbon one',
  HEADING = 'Verify your Email',
  SUBHEADING = 'We have sent you a code via email address',
  HELPER_TEXT = 'Didn\'t receive the OTP?',
  HELPER_TEXT_SPAN = 'Re-send OTP',
  BUTTON_LABEL_SUBMIT = 'Confirm',
  BUTTON_LABEL_BACK = 'Back',
}